const initialState = {
    items: [],
    single: {},
    refresh: false,
    loading: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'WORKSPACE_RESET':
            return initialState;
        case 'HIDE_SUB_BAR':
            return {
                ...state,
                single: {}
            };
        case 'WORKSPACE_SINGLE_SUCCESS':
            return {
                ...state,
                single: action.payload.data
            };
        case "WORKSPACE_GET_LOADING":
            return {
                ...state,
                loading: true
            };
        case 'WORKSPACE_GET_SUCCESS':
            return {
                ...state,
                items: action.payload.data,
                loading: false,
            };
        case 'WORKSPACE_REFRESH_TRUE':
            return {
                ...state,
                refresh: true
            };
        case 'WORKSPACE_REFRESH_FALSE':
            return {
                ...state,
                refresh: false
            };
        case 'WORKSPACES':
            return initialState;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/store/reducers/workspace.js